// Append the current URL params (gameUserId, accountUserId, callbackUrl) to a path
// so they are carried forward across all game routes. Returns the path unchanged
// when no params are present (normal flow).
export const withParams = (path) => {
  const href = window.location.href;
  const idx = href.indexOf("gameUserId=");
  if (idx === -1) return path;
  const params = href.substring(idx);
  return `${path}/${params}`;
};
